import Editor from './editor';

const ImportTreasureFiles = {
  Editor,
};

export default ImportTreasureFiles;
